
import { useNavigate, useLocation } from 'react-router-dom';

interface NavItem {
  path: string;
  icon: string;
  label: string;
  color: string;
}

const navItems: NavItem[] = [
  { path: '/', icon: 'ri-home-5-line', label: 'Início', color: '#3B82F6' },
  { path: '/perfil', icon: 'ri-user-line', label: 'Perfil', color: '#8B5CF6' },
  { path: '/mentoria', icon: 'ri-message-3-line', label: 'Mentoria', color: '#F59E0B' },
  { path: '/gamificacao', icon: 'ri-trophy-line', label: 'Gamificação', color: '#EF4444' },
  { path: '/sustentabilidade', icon: 'ri-leaf-line', label: 'Sustentabilidade', color: '#10B981' },
  { path: '/relatorios', icon: 'ri-bar-chart-line', label: 'Relatórios', color: '#EC4899' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center justify-center flex-1 h-full transition-all whitespace-nowrap cursor-pointer"
            >
              <i
                className={`${item.icon} text-xl mb-1`}
                style={{ color: isActive ? item.color : '#9CA3AF' }}
              />
              <span
                className="text-xs font-medium"
                style={{ color: isActive ? item.color : '#9CA3AF' }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
